import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { IJitB2B2CUnicomOnboardingRequest, IJitB2B2CUnicomOnboardingResult } from '@admin-panel/types';
import { axiosInstance } from './axios';

class VendorApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/vendor');
  }

  protected transformNode(node: any) {
    node.vendorBrandOptionLabel = node.name + '(' + node.brands[0].name + ')';
    return node;
  }

  async onboardJitB2B2CUnicom(
    vendorId: number | string,
    payload: IJitB2B2CUnicomOnboardingRequest,
  ): Promise<IJitB2B2CUnicomOnboardingResult> {
    const response = await axiosInstance.post(
      `${this.baseURL}/${vendorId}/jit-b2b2c-unicom-onboarding`,
      payload,
    );
    if (response.data?.success === false || response.data?.status?.type === 'ERROR') {
      throw new Error(response.data?.status?.message || 'Unable to complete Unicom setup');
    }
    return response.data.data;
  }
}

export default VendorApiClient;
